import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Card from '../../../../components/card'
import { SnackBar, SelectBox } from 'components/uikit-adapter/index'
import StyledIntegracoes from "./styledIntegracoes";
import Loading from 'components/center-loading'
import HeaderIcon from 'components/header-icon'
import { IntegrationIcon } from 'components/icons/icn-index.icon'
import intl from 'react-intl-universal'
import { getIntegracoes, getAllTiposIntegracao, getWallets, getLabeledFamilies } from "./integrations.service";
import { Switcher } from 'components/toggle';
import Input from 'components/input';

class ConfiguracoesIntegracoes extends Component {
  constructor() {
    super()

    this.state = {
      fetchingCount: 0,
      showFeedback: false,
      messageFeedback: '',
      integracoes: [],
      carteiras: [],
      familiasRotuladas: [],
      exibirTodas: false,
      filtroTexto: '',
      ordenacao: null,
      filtroStatus: null,
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  componentDidMount() {
    this.searchLabeledFamily();
    this.searchWallets();
    this.obterIntegracoes();

    this.timerID = setInterval(() => { this.obterIntegracoes() }, 60000);
  }

  obterIntegracoes = async () => {
    this.startFetching();
    try {
      const { exibirTodas } = this.state;
      let integracoes;
      if (exibirTodas) {
        integracoes = await getAllTiposIntegracao();
      } else {
        integracoes = await getIntegracoes();
      }
      this.setState({ integracoes });
    } catch (e) {
      this.proccessFeedback(e);
    }
    this.stopFetching()
  }

  startFetching = () => {
    this.setState(prev => ({ fetchingCount: prev.fetchingCount + 1 }))
  }

  stopFetching = () => {
    this.setState(prev => ({ fetchingCount: Math.max(0, prev.fetchingCount - 1) }))
  }

  searchWallets = async () => {
    this.startFetching();
    try {
      const carteiras = await getWallets();
      this.setState({ carteiras });
    } catch (e) {
      this.proccessFeedback(e);
    }
    this.stopFetching()
  }

  searchLabeledFamily = async () => {
    this.startFetching();
    try {
      const familiasRotuladas = await getLabeledFamilies();
      this.setState({ familiasRotuladas });
    } catch (e) {
      this.proccessFeedback(e);
    }
    this.stopFetching()
  }

  proccessFeedback = (message) => {
    this.setState({
      fetchingCount: 0,
      showFeedback: true,
      messageFeedback: message,
    })
  }

  closeFeedback = () => {
    this.setState({
      showFeedback: false,
      messageFeedback: ''
    })
  }

  handleToggleExibirTodas = (target) => {
    // O Switcher passa e?.target diretamente (não o evento completo)
    const exibirTodas = target?.checked ?? false;
    this.setState({ exibirTodas, filtroTexto: '' }, () => {
      this.obterIntegracoes();
    });
  }

  handleFiltroTexto = (eventOrValue) => {
    let filtroTexto = '';
    if (typeof eventOrValue === 'string') {
      filtroTexto = eventOrValue;
    } else if (eventOrValue?.target?.value !== undefined) {
      filtroTexto = eventOrValue.target.value;
    } else if (eventOrValue?.nativeEvent?.target?.value !== undefined) {
      filtroTexto = eventOrValue.nativeEvent.target.value;
    }
    this.setState({ filtroTexto });
  }

  getIntegracoesFiltradas = () => {
    const { integracoes, filtroTexto, filtroStatus } = this.state;
    let lista = Array.isArray(integracoes) ? integracoes : [];

    if (filtroTexto && filtroTexto.trim() !== '') {
      const termo = filtroTexto.toLowerCase().trim();
      lista = lista.filter(v => {
        const descricao = (v.descricaoTipoIntegracao ?? v.DescricaoTipoIntegracao ?? '').toLowerCase();
        return descricao.includes(termo);
      });
    }

    const statusValue = filtroStatus?.value;
    if (statusValue !== null && statusValue !== undefined) {
      lista = lista.filter(v => {
        const status = v.status ?? v.Status;
        const ultimaExecucaoComErro = v.ultimaExecucaoComErro ?? v.UltimaExecucaoComErro ?? false;
        // Filtro "Erro" (value=0): inclui status parado OU flag de erro na última execução
        if (statusValue === 0) {
          return status === 0 || ultimaExecucaoComErro;
        }
        return status === statusValue;
      });
    }

    return lista;
  }

  handleFiltroStatus = (option) => {
    this.setState({ filtroStatus: option ?? { value: null, label: '' } });
  }

  handleOrdenacao = (option) => {
    this.setState({ ordenacao: option ?? { value: 'nome', label: '' } });
  }

  getStatusOrdem = (v) => {
    const status = v.status ?? v.Status;
    // Em Execução (4) primeiro, depois Erro (0), Agendado (2), Preparando (3), StandBy (1)
    const ordem = { 4: 0, 0: 1, 2: 2, 3: 3, 1: 4 };
    return ordem[status] !== undefined ? ordem[status] : 5;
  }

  getIntegracoesOrdenadas = () => {
    const { ordenacao } = this.state;
    const ordenacaoValue = ordenacao?.value ?? ordenacao;
    const filtradas = this.getIntegracoesFiltradas();
    const lista = [...filtradas];

    if (ordenacaoValue === 'ultimaExecucao') {
      lista.sort((a, b) => {
        const dataA = a.dataUltimaExecucao ?? a.DataUltimaExecucao ?? null;
        const dataB = b.dataUltimaExecucao ?? b.DataUltimaExecucao ?? null;
        if (!dataA && !dataB) return 0;
        if (!dataA) return 1;
        if (!dataB) return -1;
        return new Date(dataB) - new Date(dataA);
      });
    } else if (ordenacaoValue === 'status') {
      lista.sort((a, b) => this.getStatusOrdem(a) - this.getStatusOrdem(b));
    } else {
      // padrão: nome
      lista.sort((a, b) => {
        const nomeA = (a.descricaoTipoIntegracao ?? a.DescricaoTipoIntegracao ?? '').toLowerCase();
        const nomeB = (b.descricaoTipoIntegracao ?? b.DescricaoTipoIntegracao ?? '').toLowerCase();
        return nomeA.localeCompare(nomeB);
      });
    }

    return lista;
  }

  render() {
    const {
      carteiras,
      familiasRotuladas,
      messageFeedback,
      showFeedback,
      fetchingCount,
      exibirTodas,
      filtroTexto,
      integracoes,
    } = this.state;

    const isFetching = fetchingCount > 0;

    const integracoesOrdenadas = this.getIntegracoesOrdenadas();
    const integracoesFiltradas = this.getIntegracoesFiltradas();
    const totalIntegracoes = (integracoes ?? []).length;
    const totalFiltradas = integracoesFiltradas.length;

    const opcoesOrdenacao = [
      { value: 'nome', label: intl.get('master-data.configurations.integrations.sortByName') },
      { value: 'ultimaExecucao', label: intl.get('master-data.configurations.integrations.sortByLastExecution') },
      { value: 'status', label: intl.get('master-data.configurations.integrations.sortByStatus') },
    ];

    const opcoesStatus = [
      { value: null, label: intl.get('master-data.configurations.integrations.statusAll') },
      { value: 4, label: intl.get('master-data.configurations.integrations.statusRunning') },
      { value: 0, label: intl.get('master-data.configurations.integrations.statusError') },
      { value: 2, label: intl.get('master-data.configurations.integrations.statusScheduled') },
      { value: 3, label: intl.get('master-data.configurations.integrations.statusPreparing') },
      { value: 1, label: intl.get('master-data.configurations.integrations.statusStandBy') },
    ];

    const ordenacaoValue = this.state.ordenacao ?? opcoesOrdenacao[0];
    const filtroStatusValue = this.state.filtroStatus ?? opcoesStatus[0];

    const contadorLabel = totalFiltradas === totalIntegracoes
      ? `${totalIntegracoes}`
      : `${totalFiltradas} / ${totalIntegracoes}`;
    const subtitleWithCount = totalIntegracoes > 0
      ? `${intl.get('master-data.configurations.integrations.header.subtitle')} · ${contadorLabel}`
      : intl.get('master-data.configurations.integrations.header.subtitle');

    return (
      <StyledIntegracoes>
        <Loading isLoading={isFetching} />

        <div className="integracoes-header">
          <HeaderIcon
            title={intl.get('master-data.configurations.integrations.header.title')}
            subtitle={subtitleWithCount}
            icon={<IntegrationIcon width="45px" height="45px" color='var(--color-brand-500)' />}
          />
          <div className="integracoes-header-actions">
            <div className="integracoes-search">
              <Input
                name="filtro-integracao"
                placeholder={intl.get('master-data.configurations.integrations.searchPlaceholder')}
                value={filtroTexto}
                onChange={this.handleFiltroTexto}
              />
            </div>
            <div className="integracoes-sort">
              <SelectBox
                name="ordenacao-integracao"
                label={intl.get('master-data.configurations.integrations.sortLabel')}
                dontShowLabel
                options={opcoesOrdenacao}
                value={ordenacaoValue}
                onChange={this.handleOrdenacao}
                valueKey="value"
                labelKey="label"
                clearable={false}
              />
            </div>
            <div className="integracoes-sort">
              <SelectBox
                name="filtro-status-integracao"
                label={intl.get('master-data.configurations.integrations.filterByStatus')}
                dontShowLabel
                options={opcoesStatus}
                value={filtroStatusValue}
                onChange={this.handleFiltroStatus}
                valueKey="value"
                labelKey="label"
                clearable={false}
              />
            </div>
            <div className="integracoes-toggle">
                <Switcher
                  name="exibir-todas"
                  label={intl.get('master-data.configurations.integrations.showAll')}
                  value={exibirTodas}
                  onChange={this.handleToggleExibirTodas}
                  thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                  trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                />
              </div>
          </div>
        </div>

        <SnackBar
          message={messageFeedback}
          open={showFeedback}
          autoHideDuration={4000}
          onRequestClose={this.closeFeedback}
          style={{ width: '100%', textAlign: 'center', display: 'block' }}
        />

        {integracoesOrdenadas?.map((v, i) => (
          <Card
            key={v.id ?? v.Id ?? i}
            dataCard={v}
            typeCard={'CONFIGURACAO_INTEGRACAO'}
            carteiras={carteiras}
            familiasRotuladas={familiasRotuladas}
            proccessFeedback={this.proccessFeedback}
            obterIntegracoes={this.obterIntegracoes}
          />
        ))}

        {integracoesOrdenadas?.length === 0 && !isFetching && (
          <div className="integracoes-empty">
            {intl.get('master-data.configurations.integrations.noResults')}
          </div>
        )}
      </StyledIntegracoes>
    );
  }
}

export default withRouter(ConfiguracoesIntegracoes)
